import { useParams } from 'react-router-dom'
import { Relations } from 'components/relations/relations'

export function AdminRelations() {
  const { exhibitorId, tradeshowId } = useParams()
  return <Relations isFromAdmin exhibitorId={exhibitorId} tradeshowId={tradeshowId} />
}
